import React from 'react'

const Body = ({ children, className = '' }) => {
  return (
    <div className={`h-screen-module-body ${className}`}>{children}</div>
  )
}

export default Body